import React from 'react';

import {Icon} from '@albert-io/atomic';
import type {CleverUser} from 'client/Clever/util';

import {ActionCard} from './ActionCard';
import {useCleverSync} from '../hooks/useCleverSync';

/** Has-classes "Classroom Management" tile: import / re-sync / syncing states for Clever rosters. */
export const CleverImportCard = ({user}: {user: CleverUser}) => {
  const {isSyncing, lastSyncDate, handleClick, modals} = useCleverSync(user);

  let title: string;
  let description: string | undefined;
  if (isSyncing) {
    title = 'Syncing...';
  } else if (lastSyncDate) {
    title = 'Re-sync with Clever';
    description = `Last sync: ${lastSyncDate.format('MMM D, YYYY')}`;
  } else {
    title = 'Import & Sync with Clever';
  }

  return (
    <>
      <ActionCard
        busy={isSyncing}
        data-testid='home-action__import-clever'
        description={description}
        horizontal
        iconClassName='background-blueberry-subtle content-blueberry'
        iconContent={
          <Icon icon='arrows-rotate' iconStyle='light' size='inherit' spin={isSyncing} />
        }
        onClick={handleClick}
        title={title}
        trailing={
          <Icon
            className='content-tertiary'
            icon='arrows-rotate'
            iconStyle='regular'
            size='inherit'
          />
        }
      />
      {modals}
    </>
  );
};
